module.exports = __webpack_public_path__ + "static/media/IMG_9989.686b4b9b.jpg";